// Shared utility functions

// Color palette for tags (Helferpool, Team, Shift tags)
const TAG_COLORS = [
  { bg: '#e3f2fd', text: '#1565c0' },  // Blue
  { bg: '#f3e5f5', text: '#7b1fa2' },  // Purple
  { bg: '#e8f5e9', text: '#2e7d32' },  // Green
  { bg: '#fff3e0', text: '#e65100' },  // Orange
  { bg: '#fce4ec', text: '#c2185b' },  // Pink
  { bg: '#e0f7fa', text: '#00838f' },  // Cyan
  { bg: '#fff8e1', text: '#f9a825' },  // Yellow
  { bg: '#efebe9', text: '#5d4037' },  // Brown
];

/**
 * Get a consistent color for a tag based on its name
 * @param {string} tagName - The tag name
 * @returns {{ bg: string, text: string }} - Background and text color
 */
export const getTagColor = (tagName) => {
  let hash = 0;
  for (let i = 0; i < tagName.length; i++) {
    hash = tagName.charCodeAt(i) + ((hash << 5) - hash);
  }
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
};

/**
 * Format a date string to German locale
 * @param {string} dateString - ISO date string
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string} - Formatted date
 */
export const formatDate = (dateString, options = {}) => {
  const date = new Date(dateString);
  const defaultOptions = {
    weekday: 'short',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    ...options
  };
  return date.toLocaleDateString('de-DE', defaultOptions);
};

/**
 * Format duration in minutes to human-readable string
 * @param {number} minutes - Duration in minutes
 * @returns {string} - Formatted duration
 */
export const formatDuration = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins} Min.`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};
